import { useRouter } from 'next/router';
import { createContext, useContext, useEffect } from 'react';

import { useGetMaintenanceStatusQuery } from '@hooks/maintenance/maintenance.gql.generated';

interface IMaintenanceContext {
  maintenance: boolean;
  message?: string;
}

const MaintenanceContext = createContext<IMaintenanceContext>({
  maintenance: false,
  message: '',
});

const MaintenanceProvider = (props: { children: React.ReactNode }) => {
  const { children } = props;

  const router = useRouter();

  const { data } = useGetMaintenanceStatusQuery({
    pollInterval: 3 * 60 * 1000,
  });

  const isInMaintenance = data?.maintainStatus.maintain ?? false;
  const message = data?.maintainStatus.message ?? '';

  useEffect(() => {
    if (isInMaintenance) router.push('/maintenance');
  }, [isInMaintenance]);

  const value = {
    maintenance: isInMaintenance,
    message,
  };

  return <MaintenanceContext.Provider value={value}>{children}</MaintenanceContext.Provider>;
};

export const useMaintenance = () => {
  const context = useContext(MaintenanceContext);

  if (!context) {
    throw new Error('useMaintenance must be used within MaintenanceProvider');
  }

  return context;
};

export default MaintenanceProvider;
